const initialState = {
    studentCoins: 0,
    learningContentCategories: [],
    selectedLearningContentCategoryId: null,
    learningContents: [],
    selectedLearningContentId: null,
    learningContent: {},
    recommendLearningContents: [],
    nonTraitLearningContents: [],
    listEmojis: [],
    completedLearningContents:[],
    completedRecommendedLearningContentsCount: 0,
    availableLearningContentsCount: 0,
    completeCount:0,
}

const learningContentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_STUDENT_COINS':
            return { ...state, studentCoins: action.studentCoins };
        case 'SET_LEARNING_CONTENT_CATEGORIES':
            return { ...state, learningContentCategories: action.learningContentCategories };
        case 'SET_LEARNING_CONTENT_CATEGORY_ID':
            return { ...state, selectedLearningContentCategoryId: action.selectedLearningContentCategoryId };
        case 'SET_LEARNING_CONTENTS':
            return { ...state, learningContents: action.learningContents };
        case 'SET_LEARNING_CONTENT_ID':
            return { ...state, selectedLearningContentId: action.selectedLearningContentId };
        case 'SET_LEARNING_CONTENT':
            return { ...state, learningContent: action.learningContent };
        case 'SET_RECOMMEND_LEARNING_CONTENTS':
            return { ...state, recommendLearningContents: action.recommendLearningContents };
        case 'SET_NONTRAIT_LEARNING_CONTENTS':
            return { ...state, nonTraitLearningContents: action.nonTraitLearningContents };
        case 'SET_LIST_EMOJIS':
            return { ...state, listEmojis: action.listEmojis };
        case 'SET_COMPLETED_LEARNING_CONTENTS':
            return {...state, completedLearningContents: action.completedLearningContents};
        case 'SET_COMPLETED_LEARNING_CONTENTS_COUNT':
            return {...state, completeCount: action.completeCount};
        case 'SET_COMPLETED_RECOMMENDED_LEARNING_CONTENTS_COUNT':
            return {...state, completedRecommendedLearningContentsCount: action.completedRecommendedLearningContentsCount};
        case 'SET_AVAILABLE_LEARNING_CONTENTS_COUNT':
            return {...state, availableLearningContentsCount: action.availableLearningContentsCount};
        default:
            return state;
    }
}

export { learningContentReducer as default }